import React, {Fragment, PureComponent} from 'react';

import {connect} from 'react-redux';
import {InputItem, Button, Toast, WingBlank, Modal} from 'antd-mobile';
import {
    sendMessageActionResult,
    updateUserInfo,
    getUserInfo
} from './store/actionCreators';
import './index.scss';
import history from '../../utils/history';
import PublicHeader from './../../components/header/index';

const alert = Modal.alert;

class Modify extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
        }
        this.init();
    }


    componentDidMount() {
        let storage = Storage.Base.getInstance();
        let oauthInfo = storage.get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        this.props.getUserInfo();
    }

    init() {
        this.bindEvent();
    }

    bindEvent() {
        this.handleSendCode = this.handleSendCode.bind(this);
        this.updateUserInfo = this.updateUserInfo.bind(this);
    }

    async updateUserInfo() {

        let phone = this.phoneRef.state.value;
        let smsCode = this.validateRef.state.value;
        let name = this.cardName.state.value;

        if (!name) {
            Toast.info("请输入会员名！")
            return;
        }
        if (!phone) {
            Toast.info("请输入手机号！")
            return;
        }

        if (!smsCode) {
            Toast.info("请输入短信验证码！")
            return;
        }

        const data = {
            cardName: name,
            phone: phone,
            smsCode: smsCode,
        };

        const result = await this.props.updateUserInfo(data);

        if (result.data.success) {
            Toast.success('个人资料更新成功', 3, () => {
                window.location.href = `/my`;
            });
        } else {
            Toast.info(result.data.error);
        }

    }

    async handleSendCode() {
        var time = 60;
        var that = this;
        if (this.state.sendStatus === 1) {
            return;
        }

        const data = {
            type: '3',
            smsType: "3",
            phone: this.phoneRef.state.value
        };

        data.phone = data.phone.replace(/\s+/g, "");

        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }

        const result = await this.props.handleSendCode(data);

        console.log("result", result)
        if (result.status === 200) {
            Toast.success("发送成功");
        } else {
            Toast.fail('网络异常', 1);
        }

        setInterval(function () {
            if (time <= 0) {
                that.setState({
                    sendMessage: '发送验证码',
                })
            }
            else {
                that.setState({
                    sendMessage: time + "s后重新获取",
                    sendStatus: 1
                });
                time--;
            }
        }, 1000);
    }

    alertTip = () => {
        alert('确认修改资料', '您确认要修改资料吗？', [
            {text: '取消', onPress: () => console.log('cancel')},
            {text: '确认', onPress: () => this.updateUserInfo()},
        ])
    }

    render() {
        const {sendMessage} = this.state;
        const {modifyUserInfo = {}} = this.props;
        console.log("1111", modifyUserInfo)
        const {cardNo = "", name, tel} = modifyUserInfo;
        return (
            <div>
                <PublicHeader title="更新资料"/>
                <WingBlank size="md">
                    <div className="forget-password-wrapper">
                        <InputItem
                            clear
                            placeholder="会员卡号"
                            maxLength="60"
                            disabled
                            value={cardNo}
                        >会员卡号：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.cardName = el}
                            placeholder="输入会员名"
                            maxLength="60"
                        >会员名：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.phoneRef = el}
                            placeholder="输入手机号码"
                            maxLength="11"
                        >手机号：</InputItem>
                        <InputItem
                            clear
                            ref={el => this.validateRef = el}
                            placeholder="输入验证码"
                            extra={<span style={{color:"#FD9D24"}}>{sendMessage}</span>}
                            onExtraClick={this.handleSendCode}>
                            验证码：
                        </InputItem>
                        <Button style={{
                            backgroundColor: "#FD9D24",
                            color: "#FFFFFF",
                            margin: "60px 80px 20px 80px",
                            height: "40px",
                            lineHeight: "40px"
                        }}
                                onClick={this.alertTip}>
                            更新资料</Button>
                    </div>
                </WingBlank>
            </div>
        )
    }
}

const mapStateToProps = (modify) => {
    return {
        modifyUserInfo: modify.modify.modifyUserInfo
    }
};

const mapDispatchToProps = (dispatch) => ({
    handleSendCode: data => dispatch(sendMessageActionResult(data)),
    updateUserInfo: data => dispatch(updateUserInfo(data)),
    getUserInfo: () => dispatch(getUserInfo()),
});
export default connect(mapStateToProps, mapDispatchToProps)(Modify);